const messages = {
  ko: {
    login: {
      title: '로그인',
      username: '사용자명',
      password: '비밀번호',
      loginButton: '로그인',
      loginError: '로그인에 실패했습니다.'
    },
    common: {
      loading: '로딩 중...',
      error: '오류가 발생했습니다.',
      success: '성공했습니다.'
    }
  },
  en: {
    login: {
      title: 'Login',
      username: 'Username',
      password: 'Password',
      loginButton: 'Login',
      loginError: 'Login failed.'
    },
    common: {
      loading: 'Loading...',
      error: 'An error occurred.',
      success: 'Success.'
    }
  },
  ja: {
    login: {
      title: 'ログイン',
      username: 'ユーザー名',
      password: 'パスワード',
      loginButton: 'ログイン',
      loginError: 'ログインに失敗しました。'
    },
    common: {
      loading: '読み込み中...',
      error: 'エラーが発生しました。',
      success: '成功しました。'
    }
  },
  zh: {
    login: {
      title: '登录',
      username: '用户名',
      password: '密码',
      loginButton: '登录',
      loginError: '登录失败。'
    },
    common: {
      loading: '加载中...',
      error: '发生错误。',
      success: '成功。'
    }
  }
}

export default messages